import Button from "@/atomic/atoms/Button";
import Header from "@/atomic/atoms/Header";
import { InputMask } from "@react-input/mask";
import { PropsView } from "../Models/address";
import Modal from "@/atomic/atoms/Modal";
import Loading from "@/atomic/atoms/Loading";
import { Suspense } from "react";

export default function RegisterAddressView({
  goBack,
  isDisabled,
  editable,
  isVisibleModal,
  toggleModal,
  isLoading,
  register,
  errors,
  handleSubmit,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Endereço"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Seu endereço</h2>
            <div className="flex flex-col justify-center">
              <InputMask 
                {...register("zipcode")}
                name="zipcode"
                required 
                type="text"
                inputMode="numeric"
                mask="_____-___"
                replacement={{ _: /\d/ }}
                placeholder="Seu CEP"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.zipcode && (
                <span className="text-red-500 text-xs">{errors.zipcode.message as string}</span>
              )}
              <div className="w-full flex flex-row justify-between">
                <div className="mt-3 w-[calc(49%)]">
                  <input 
                    {...register("streetName")}
                    required 
                    type="text" 
                    name="streetName" 
                    placeholder="Logradouro" 
                    disabled={!editable}
                    className="w-full text-base text-black w-[calc(65%)] bg-transparent border p-2 rounded-lg h-14"
                  />
                  {errors.streetName && (
                    <span className="text-red-500 text-xs">{errors.streetName.message as string}</span>
                  )}
                </div>
                <div className="mt-3 w-[calc(49%)]">
                  <input 
                    {...register("number")}
                    required 
                    type="text" 
                    name="number" 
                    placeholder="Nº" 
                    className="w-full text-base text-black w-[calc(34%)] bg-transparent border p-2 rounded-lg h-14"
                  />
                  {errors.number && (
                    <span className="text-red-500 text-xs">{errors.number.message as string}</span>
                  )}
                </div>
              </div>
              <input 
                {...register("complement")}
                type="text" 
                name="complement" 
                placeholder="Complemento" 
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.complement && (
                <span className="text-red-500 text-xs">{errors.complement.message as string}</span>
              )}
              <input 
                {...register("neighborhood")}
                required 
                type="text" 
                name="neighborhood" 
                placeholder="Bairro" 
                disabled={!editable}
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.neighborhood && (
                <span className="text-red-500 text-xs">{errors.neighborhood.message as string}</span>
              )}
              <div className="w-full flex flex-row justify-between">
                <div className="mt-3 w-[calc(65%)]">
                  <input 
                    {...register("city")}
                    required 
                    type="text" 
                    name="city" 
                    placeholder="Cidade" 
                    disabled={!editable}
                    className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                  />
                  {errors.city && (
                    <span className="text-red-500 text-xs">{errors.city.message as string}</span>
                  )}
                </div>
                <div className="mt-3 w-[calc(34%)]">
                  <InputMask 
                    {...register("state")}
                    name="state"
                    required 
                    type="text"
                    mask="__"
                    replacement={{ _: /\D/ }}
                    placeholder="UF"
                    disabled={!editable}
                    className="uppercase text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                  />
                  {errors.state && (
                    <span className="text-red-500 text-xs">{errors.state.message as string}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Button 
            className="rounded-xl bg-primary text-white"
            title="Continuar"
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {isVisibleModal &&  <Suspense fallback={null}>
        <Modal 
          title="Atenção"
          message="Cep inválido"
          actionMessage="Usar outro cep"
          action={toggleModal}
        />
      </Suspense>}
      {isLoading && <Suspense fallback={null}>
        <Loading />
      </Suspense>}
    </div>
  );
}
